import styled from 'styled-components';

export const StepSubtitle = styled.span`
    padding-left: 4px;
    opacity: 0.4
`;